import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
    AppBar,
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Stack,
    TextField,
    Toolbar,
    Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AgGridTable from "../utilities/AgGridTable";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import moment from "moment";

const ViewProformaInvoiceData = (props) => {
    const gridRef = useRef();
    const voucherGridRef = useRef();
    const [formOpen, setFormOpen] = useState(props.viewPI || false);
    const [rowData, setRowData] = useState([]);
    const [voucherRowData, setVoucherRowData] = useState([]);
    const [view, setView] = useState([]);
    const [viewDataOptions, setViewDataOptions] = useState([
        { label: "History", value: "History" },
        { label: "Related Voucher", value: "Related Voucher" },
    ]);
    const [gridApi, setGridApi] = useState();
    const [voucherGridApi, setVoucherGridApi] = useState();
    const PIurl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.ProformaInvoice}`;

    const renderCurrency = (props) => {
        return <span style={{ display: "flex" }}>
            <p>{props?.value && new Intl.NumberFormat('en-US').format(props?.value)}</p>
        </span>;
    };
    const valueDateFormatter = (props) => {
        if (props.value) {
            return moment
                (props.value).format('DD-MM-YYYY')
        } else {
            return '';
        }
    }

    const [columnDefs, setColumnDefs] = useState([
        {
            field: "revisionDate",
            headerName: "Date",
            minWidth: 150,
            checkboxSelection: false,
            valueFormatter: valueDateFormatter,
            headerCheckboxSelection: false,
        },
        { field: "revisionBy", headerName: "User", minWidth: 150 },
        { field: "event", headerName: "Event", minWidth: 150 },
        { field: "value", headerName: "Value", minWidth: 150, cellRenderer: renderCurrency },
    ]);

    const [voucherColumnDefs, setVoucherColumnDefs] = useState([
        {
            field: "voucherNo",
            headerName: "Voucher No",
            minWidth: 150,
            checkboxSelection: false,
            headerCheckboxSelection: false,
        },
        { field: "postDate", headerName: "Date", minWidth: 150,
        valueFormatter: valueDateFormatter, },
        { field: "createdBy", headerName: "Created By", minWidth: 150 },

    ]);

    const showPIData = () => {
        setFormOpen(true);
    };

    const handleViewClose = () => {
        setFormOpen(false);
    };

    const loadViewHistoryData = async () => {
        const history = await OAuthService.getList(PIurl + `/piRevisions/${props?.data?.piNumber}`);

        const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;

        const userlist = await OAuthService.getList(
            userUrl + `?sort=firstName,asc&size=1000`
        );
        const users = [];
        userlist.data?._embedded?.users.map((data, key) => {
            data.name = data.firstName + " " + data.lastName;
            users[data.email] = data.name;
            return data;
        });
        if (history?.data) {
            const dataList = history?.data.map((data) => {
                data.revisionBy = users[data.revisionBy]
                return data
            })
            setRowData(dataList)
        }
    };
    const loadViewVoucherData = async () => {
        try {
            const related = await OAuthService.getList(PIurl + `/getPiVouchers/${props?.data?.piNumber}`);
            const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;

            const userlist = await OAuthService.getList(
                userUrl + `?sort=firstName,asc&size=1000`
            );
            const users = [];
            userlist.data?._embedded?.users.map((data, key) => {
                data.name = data.firstName + " " + data.lastName;
                users[data.email] = data.name;
                return data;
            });
            if (related?.data) {
                const dataList = related?.data.map((data) => {
                    data.createdBy = data.createdBy && users[data.createdBy]
                    data.createdAt = data.createdAt && moment(data.createdBy).format('DD-MM-YYYY')
                    return data
                })
                setVoucherRowData(dataList)
            }
        } catch (error) {

        }
    };

    const handleChangeViewData = (value) => {
        setView(value.value);
        if (value.value === 'History') {
            loadViewHistoryData()
        } else {
            loadViewVoucherData()
        }
    };

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    const onVoucherGridReady = (params) => {
        setVoucherGridApi(params.api);
    };

    useEffect(() => {
        props.handleViewForm(formOpen)
    }, [formOpen])

    return (
        <>
            <Dialog
                open={formOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth={"md"}
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full justify-between">
                        <Typography variant="subtitle1" color="inherit">
                            Proforma Invoice
                        </Typography>
                        <Button onClick={handleViewClose}>
                            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                        </Button>
                    </Toolbar>
                </AppBar>
                <div className="p-20">
                    <label>Proforma Invoice View Data</label>
                    <Select
                        name="viewData"
                        className="w-[25%] h-[100%] "
                        // className="w-[85px] h-[20px]"
                        value={
                            view &&
                            viewDataOptions.length > 0 &&
                            viewDataOptions.filter((list) => list.value === view)
                        }
                        onChange={handleChangeViewData}
                        options={viewDataOptions}
                        styles={customStyles("", "", "0px")}
                    />
                </div>
                {view === "History" ? (
                    <>
                        <DialogTitle>
                            <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
                                <span>Proforma History</span>
                            </div>
                        </DialogTitle>
                        <DialogContent>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <div className="flex items-baseline">
                                        <label className="float-left pr-5 ">PI Number</label>
                                        <TextField
                                            name="pi_number"
                                            value={props?.data?.piNumber}
                                            // onChange={handlechangecompany}
                                            inputProps={{
                                                sx: { padding: "10px" },
                                            }}
                                            disabled
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} className="mt-16">
                                <div className="flex items-baseline">
                                    <Grid item xs={6}>
                                        <div className="flex items-baseline">
                                            <label className=" float-left pr-5 pl-5 ">Customer</label>
                                            <TextField
                                                name="custnum"
                                                value={props?.data?.custNum}
                                                // onChange={handlechangecompany}
                                                inputProps={{
                                                    sx: { padding: "10px" },
                                                }}
                                                disabled
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            name="custnum"
                                            value={props?.data?.custName}
                                            // onChange={handlechangecompany}
                                            inputProps={{
                                                sx: { padding: "10px" },
                                            }}
                                            disabled
                                            style={{ marginTop: "-10px", marginLeft: "10px" }}
                                        />
                                    </Grid>
                                </div>
                            </Grid>
                            <Divider className="mt-10" sx={{ borderBottomWidth: 3 }} />
                            <Grid container>
                                <Grid item xs={12} className="h-[300px] mt-10">
                                    <AgGridTable
                                        onGridReady={onGridReady}
                                        columnDefs={columnDefs}
                                        rowData={rowData}
                                        gridRef={gridRef}
                                        floatingFilter={false}
                                        rowGroupPanelShow="never"
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </>
                ) : (
                    view === "Related Voucher" && (
                        <>
                            <DialogTitle>
                                <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
                                    <span>Related Vouchers Pop Up</span>
                                </div>
                            </DialogTitle>
                            <DialogContent>
                                <div className="h-[300px]">
                                    <AgGridTable
                                        onGridReady={onVoucherGridReady}
                                        columnDefs={voucherColumnDefs}
                                        rowData={voucherRowData}
                                        gridRef={voucherGridRef}
                                        floatingFilter={false}
                                        rowGroupPanelShow="never"
                                    />
                                </div>
                            </DialogContent>
                        </>
                    )
                )}
            </Dialog>
        </>
    );
};
export default ViewProformaInvoiceData;
